import styled from 'styled-components';

import {
  DateRangePicker,
} from 'react-date-range';

import {
  Popup as SemanticPopup,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Text as TextLayout } from '@playbookux/playbook-web-core';

const PopupDatePicker = styled(SemanticPopup)``;

const SelectField = styled.div`
    cursor: pointer;
    word-wrap: break-word;
    line-height: 1em;
    white-space: normal;
    outline: 0;
    transform: rotateZ(0);
    min-width: 14em;
    height: 40px;
    display: inline-block;
    padding: .78em 1.1em .78em 1em;
    box-shadow: none;
    border: 1px solid rgba(34,36,38,.15);
    border-radius: .28rem;
    transition: box-shadow .1s ease,width .1s;
    color: rgba(191,191,191,.87);

    :hover {
      border-color: rgba(34,36,38,.35);
      box-shadow: none;
    }
`;

const IconCalendar = styled(SemanticIcon)`
  &&& {
    color: ${({ theme }) => theme.color.multipleDropdownHover};
  }
`;

const ConainerText = styled.div`
  display: flex;
  align-items: center;
`;

const Text = styled(TextLayout)`
  ${({ nomargin }) => (nomargin ? '' : 'margin-left: 15px;')}
`;

const DateRangePickerPopup = styled(DateRangePicker)``;

export {
  PopupDatePicker,
  SelectField,
  IconCalendar,
  ConainerText,
  Text,
  DateRangePickerPopup,
};
